import React from 'react';
import Rollbar from 'rollbar';

import { compose } from 'recompose';
import { Icon, Message, Divider } from 'semantic-ui-react';
import BrowserDetection from 'react-browser-detection';
import ThemeSelector from '../../themes/theme-selector';
import BrowserHandler from '../../utils/browser-handler';
import PoweredByDyzio from '../../components/powered-by-dyzio';
import withIntercom from '../../hocs/with-guest-intercom';

const theme = ThemeSelector.theme();

const AccessDenied = () => {
  const parsedHash = new URLSearchParams(
    window.location.hash.substr(1), // skip the first char (#)
  );
  const error = decodeURIComponent(parsedHash.get('error'));

  let errorDescription = decodeURIComponent(parsedHash.get('error_description'));

  if (errorDescription.match(/Object/)) {
    errorDescription = 'We could not find a user with your email address in our database.';
  }

  const rollbar = new Rollbar({
    accessToken: '3affd941e3d0437ea5f446c0a2769419',
    captureUncaught: true,
    payload: {
      environment: window.location.hostname,
      person: {
        id: 401,
        username: 'Erroneous Bosch',
        email: 'x@y.com',
      },
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: 'latest',
          guess_uncaught_frames: true,
        },
      },
    },
  });

  rollbar.error(`ACCESS_DENIED_ERROR-${error}`, errorDescription);

  return (
    <div className="page-centered">
      <div className="center-outer">
        <div className="center-inner">
          <div className="center-logo">
            <a href="/"><img src={theme.darkLogo.src} alt={theme.darkLogo.alt} /></a>
          </div>
          <div className="center-content">
            <div className="spacer small" />
            <h1 style={{ textAlign: 'center' }}>
            Sorry...<br />We had a problem signing you in <Icon name="frown" color="red" />
            </h1>
            <div className="spacer" />
            <p className="info">Our support team has been notified and will be in touch shortly.</p>
            <hr />
            <p className="info">
              You can also use the chat button in the bottom right of your screen to contact us directly.
            </p>
            <Divider hidden />
            <Message
              warning
              header={error}
              content={errorDescription}
            />
          </div>
        </div>
        <div className="browser-detect" style={{ textAlign: 'center', paddingTop: 50 }}>
          <PoweredByDyzio />
          <BrowserDetection>
            {BrowserHandler.handle}
          </BrowserDetection>
        </div>
      </div>
    </div>
  );
};

export default compose(withIntercom)(AccessDenied);



/** WEBPACK FOOTER **
 ** ./src/components/access-denied/index.js
 **/